import { Component, OnInit, Input } from '@angular/core';
import { OHNElement } from '../../../models/ohn-instances';

@Component({
  selector: 'app-noise-level-element-config',
  templateUrl: './noise-level-element-config.component.html',
  styleUrls: ['./noise-level-element-config.component.scss'],
})
export class NoiseLevelElementConfigComponent implements OnInit {

	@Input() el: OHNElement;

  constructor() { }

  ngOnInit() {}

}
